<template>
  <div class="fp-step">
    <div class="fp-step-header">
      <button type="button" class="fp-back-btn" @click="$emit('go-back')" t_label="btn_emp2_Back_ForgotPasswordEmail">
        <img 
          src="https://cdn.adsalecdn.com/EMP/2-0/BuyerIdx/All_Categories.svg" 
          alt="back" 
          class="fp-back-icon"
        />
      </button>
      <h1 class="fp-step-title">{{ $t('lbl_emp2_RetrieveAccountName') }}?</h1>
    </div>

    <div class="fp-form-group">
      <div class="fp-info-text">
        {{ $t('lbl_emp2_EnterAdminEmailRetrieveUsername') }}
      </div>
    </div>

    <div class="fp-form-group">
      <div class="fp-input-wrapper">
        <div class="fp-input-container">
          <label
            v-if="shouldShowLabel(forgotEmail, forgotEmailError)"
            class="input-label"
            :class="{ 'label-error': forgotEmailError }"
          >
            {{ $t('lbl_emp2_Email') }} <span class="required">*</span>
          </label>
          <span
            v-if="shouldShowPlaceholder(forgotEmail, forgotEmailError)"
            class="input-placeholder"
          >
            {{ $t('lbl_emp2_Email') }} <span class="required">*</span>
          </span>
          <input
            :value="forgotEmail"
            type="email"
            name="email"
            id="forgot-password-email-field"
            autocomplete="email"
            class="form-input-placeholder"
            :class="{ 'input-error': forgotEmailError }"
            placeholder=""
            @focus="() => onFocus('clear-forgot-email-error')"
            @blur="onBlur"
            @input="handleInput"
          />
        </div>
        <div v-if="forgotEmailError" class="fp-error-message">
          {{ $t('lbl_emp2_InvalidEmail') }}
        </div>
      </div>
    </div>

    <button
      class="fp-btn-primary"
      @click="$emit('continue')"
      :disabled="!isValidForgotEmail || loading"
      t_label="btn_emp2_Continue_ForgotPasswordEmail"
    >
      {{ $t('lbl_emp2_Continue') }}
    </button>
  </div>
</template>

<script>
import inputMixin from '../Common/input-mixin.js';
import { validateEmail } from '../Common/utils.js';

export default {
  name: 'ForgotPasswordEmail',
  mixins: [inputMixin],
  props: {
    forgotEmail: {
      type: String,
      default: ''
    },
    forgotEmailError: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isValidForgotEmail() {
      return validateEmail(this.forgotEmail);
    }
  },
  methods: {
    handleInput(event) {
      this.handleInputGeneric(event, 'update:forgotEmail', 'clear-forgot-email-error');
    }
  }
};
</script>

<style>
@import '../Common/new-login-shared.css';
</style>

<style scoped>
/* 组件特定样式覆盖：只保留容器本身的定位，输入和标签样式使用共享文件 */
.fp-input-container {
  width: 100%;
  position: relative;
  overflow: visible;
}
</style>

